import { useLocation, useNavigate } from "react-router-dom";
import { esRutaInternaSegura } from "../lib/navegacionSegura";

// Botón global "Volver", reutilizable en toda pantalla secundaria/ficha/
// editor/vista de detalle. Nunca depende exclusivamente de
// `window.history.back()` (el historial del navegador puede no tener nada
// interno, o el usuario pudo llegar por deep-link): prioriza
// `location.state.from` (la ubicación interna que dejó quien navegó hacia
// acá, ej. `navigate(destino, { state: { from: rutaActualConFiltros } })`)
// y si no hay una válida, cae a `rutaPadre` — una ruta padre segura fija
// que cada pantalla define. `location.state.from` siempre se valida con
// `esRutaInternaSegura` antes de usarse, para que un valor manipulado
// nunca pueda sacar al usuario del ERP (open redirect).
export function BotonVolver({
  rutaPadre,
  etiqueta = "Volver",
  className = "",
}: {
  rutaPadre: string;
  etiqueta?: string;
  className?: string;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const previo = (location.state as { from?: string } | null)?.from;
  const usaDestinoDinamico = esRutaInternaSegura(previo);
  const destino = usaDestinoDinamico ? previo : rutaPadre;
  // Si el destino real es dinámico (volvemos a donde vino el usuario, no a
  // rutaPadre), la etiqueta fija ("Volver a Expedientes", etc.) mentiría
  // sobre a dónde lleva el botón — se muestra un rótulo genérico en ese caso.
  const etiquetaMostrada = usaDestinoDinamico ? "Volver" : etiqueta;

  return (
    <button
      type="button"
      onClick={() => navigate(destino)}
      className={`inline-flex items-center gap-1.5 text-sm text-texto-secundario transition-colors hover:text-texto focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secundario focus-visible:ring-offset-2 ${className}`}
    >
      <span aria-hidden="true">←</span>
      {etiquetaMostrada}
    </button>
  );
}
